export const firstLetterCapitalize = (text) => {
    return text[0].toUpperCase() + text.slice(1)
};


// WEBPACK FOOTER //
// ./src/util/text.js